import { ReactNode } from "react";
import { Container as ContainerStyled } from "./Container.styled";

const Container = ({ children }: { children: ReactNode }) => {
  return <ContainerStyled>{children}</ContainerStyled>;
};

export default Container;
